import React, { Component, PropTypes } from 'react';
import AppPage from 'components/AppPage';
import {
  CourseActions,
  AppActions,
  AuthActions,
  PageLayoutActions,
  PageActions,
} from 'actions';
import { ThemeStore, AuthStore, CourseStore, QuizStore, PageStore } from 'stores';
import MediaQuery from 'services/MediaQuery';
import ModuleMenu from 'components/ModuleMenu';
import PageRow from 'components/Page/Row';
import ScrollableContainer from 'components/ScrollableContainer';
import {
  Paper,
  RaisedButton,
  IconButton,
  Dialog,
  FloatingActionButton,
  Toolbar,
  ToolbarGroup,
  ToolbarTitle,
  Styles
} from 'material-ui';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import SlidingPanel from 'components/SlidingPanel';
import CSSPropertyOperations from 'react/lib/CSSPropertyOperations';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import shallowEqual from 'shallowequal';
import Loader from 'components/Material/Loader';
import { mixin, RefluxMixin } from 'Util';
import PageLayoutContainer from 'containers/PageLayoutContainer';
import QuizContainer from 'containers/QuizContainer';
import PageModuleMenuContainer from 'containers/PageModuleMenuContainer';
import PageLayoutStore from 'stores/PageLayout';
import { getPureLayout } from 'selectors/pageLayout';
import NotesContainer from '../../containers/NotesContainer';

const css = oxygenCss({
  nextControl: {
    textAlign: 'right',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    left: '50%',
    lineHeight: '32px',
    padding: '16px 32px 16px 24px',
    fontSize: 16,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '@phone': {
      fontSize: 12,
      padding: '0px',
      lineHeight: '0px',
      display: 'inline-block',
      height: '64px',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  },
  nextControlIcon: {
    width: 32,
    height: 32,
    display: 'inline-block',
    verticalAlign: 'middle',
    position: 'absolute',
    top: '50%',
    marginTop: -16,
    bottom: 0,
    right: 8,
    '@phone': {
      right: 4,
      top: '50%',
      transform: 'translateY(-50%)',
      marginTop: 0
    }
  },
  nextControlText: {
    '@phone': {
      position: 'absolute',
      marginRight: '32px',
      right: '0px',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  },
  prevControl: {
    textAlign: 'left',
    cursor: 'pointer',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    right: '50%',
    lineHeight: '32px',
    padding: '16px 24px 16px 32px',
    fontSize: 16,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis', // IE 6+, FF 7+, Op 11+, Saf 1.3+, Chr 1+ support
    '@phone': {
      fontSize: 12,
      padding: '0px',
      lineHeight: '0px',
      display: 'inline-block',
      height: '24px',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  },
  prevControlIcon: {
    width: 32,
    height: 32,
    display: 'inline-block',
    verticalAlign: 'middle',
    position: 'absolute',
    top: '50%',
    marginTop: -16,
    bottom: 0,
    left: 8,
    '@phone': {
      left: 4,
      top: 0,
      marginTop: 0
    }
  },
  prevControlText: {
    '@phone': {
      position: 'absolute',
      marginTop: '13px',
      marginLeft: '32px'
    }
  },
  footer: {
    position: 'absolute',
    height: 64,
    left: 0,
    right: 0,
    bottom: 0
  },
  pageDisplay: {
    display: 'inline-block',
    verticalAlign: 'top',
    position: 'relative',
    left: 0
  },
  pageDisplayNonPhone1: {
    fontFamily: 'MaisonNeue-Medium',
    letterSpacing: '1px',
    fontSize: '16px',
    lineHeight: '20px',
    marginLeft: '10px',
    marginTop: '10px',
    width: '300px'
  },
  pageDisplayNonPhone2: {
    fontFamily: 'MaisonNeue-Medium',
    letterSpacing: '1px',
    fontSize: '16px',
    lineHeight: '20px',
    marginLeft: '10px',
    marginTop: '20px',
    width: '300px'
  },
  pageDisplayTitle: {
    fontFamily: 'MaisonNeue-Medium',
    letterSpacing: '1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '60px',
    width: '480px',
    whiteSpace: 'nowrap',
    '@phone': {
      fontSize: '12px',
      width: '240px'
    }
  },
  pageDisplaySubTitle: {
    fontFamily: 'MaisonNeue-Book',
    color: '#393939',
    fontSize: '10px',
    lineHeight: '20px',
    letterSpacing: '0.5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  page: {
    height: '100%',
    paddingBottom: 42,
    boxSizing: 'border-box',
    zIndex: 1,
    transition: 'all 0.5s ease',
    position: 'relative'
  }
});

const generateKey = pre => {
  return `${pre}_${new Date().getTime()}`;
};

const { Spacing } = Styles;

const styles = {
  toolbar: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: Colors.Colors.fullWhite
  },
  toolbarTitle: {
    color: Colors.Colors.fullWhite
  },
  buttonContainer: {
    // width: Spacing.desktopKeylineIncrement * 6,
    margin: 'auto',
    padding: Spacing.desktopGutterMini
  },
  toc: {
    position: 'fixed',
    left: 0,
    top: 0,
    bottom: 0,
    width: Spacing.desktopKeylineIncrement * 6,
    transition: 'all 0.5s ease',
    zIndex: 2
  }
};

export default class Page extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    muiTheme: PropTypes.object,
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  state = {
    mode: '',
    quiziframeHasBeenChecked: false,
  };

  listenToStores() {
    this.listenToStore(PageStore);
    this.listenToStore(CourseStore);
    this.listenToStoreWithMapper(QuizStore, state => ({
      pageId: state.pageId
    }));
    this.listenToStore(AuthStore, 'auth');
    this.listenToStoreWithMapper(PageLayoutStore, state => {
      return {
        layout: getPureLayout(state)
      };
    });
  }

  listenToActions() {
    this.listenToAction(CourseActions.addPageModuleComplete, () => {
      this.refs.page.scrollToEnd();
    });
  }

  onMenuChange(e, key, payload) {}

  _gotoPage(sectionPage) {
    let { course } = this.state;
    let { page, chapter } = sectionPage;
    this.props.router.push(
      `/course/${course.ownerSlug}/${course.slug}/${chapter.slug}/${
        page.slug
      }/${page.id}`
    );
  }

  _newModule(type) {
    // PageService.createPageModule(type, this.state.page.id, response => {
    //   Message.info(this.context.getIntlMessage('pageModule.created'));
    //   if (response.data && response.data.pageRows) {
    //     this.setState({page: {
    //       ...this.state.page,
    //       pageRows: this.state.page.pageRows.concat(response.data.pageRows)
    //     }});
    //     this.closeModuleMenu();
    //   }
    // });
    CourseActions.addPageModule(type, this.state.page.id);

    this.closeModuleMenu();
  }

  getToolbarStyle(tocEnabled) {
    let style = {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      height: 60,
      zIndex: 2,
      borderStyle: 'none none solid none',
      borderWidth: '1px',
      borderColor: '#DDD',
      backgroundColor: this.context.muiTheme.rawTheme.cardColor,
      paddingLeft: 0,
      paddingRight: 0,
      boxSizing: 'border-box',
      boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)'
    };
    return style;
  }

  onScrollToBottom() {}

  getFloatingActionButtonStyle() {
    const { media } = this.context;
    const phone = media === 'phone' || media === 'tablet';
    let style,
      componentTheme = this.context.muiTheme;
    if (phone) {
      style = {
        position: 'fixed',
        right: Spacing.desktopGutter,
        bottom: Spacing.desktopGutterMini + 64,
        zIndex: 23
      };
    } else {
      style = {
        position: 'fixed',
        right: Spacing.desktopKeylineIncrement / 2,
        top:
          componentTheme.toolbar.height -
          componentTheme.floatingActionButton.buttonSize / 2,
        zIndex: 23
      };
    }

    return style;
  }

  componentWillReceiveProps(nextProps) {
    const oldParams = this.props.params;
    const newParams = nextProps.params;
    if (!shallowEqual(oldParams, newParams)) {
      const editor = this.state.auth.role.editor;
      if (newParams.pageId) {
        CourseActions.getPageById(newParams.pageId, editor);
      } else {
        CourseActions.getPageBySlug(
          newParams.ownerSlug,
          newParams.courseSlug,
          newParams.sectionSlug,
          newParams.pageSlug
        );
      }
    }
    const { course, page } = this.state;
    CourseActions.refetchToc();
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    let params = this.props.routeParams;

    if (params.pageId) {
      CourseActions.getPageById(params.pageId);
    } else {
      CourseActions.getPageBySlug(
        params.ownerSlug,
        params.courseSlug,
        params.sectionSlug,
        params.pageSlug
      );
    }
  }

  componentDidMount() {
    window.addEventListener('keyup', this.onPageNavigate);
  }

  onPageNavigate = e => {
    e.preventDefault();

    let params = this.props.routeParams;
    const { router } = this.props;
    const pageId = parseInt(params.pageId, 10);
    let next = CourseStore.getNextForPageId(pageId);
    let previous = CourseStore.getPreviousForPageId(pageId);

    if (this.state.mode == 'reader') {
      if (next && e.keyCode == 39) {
        router.push(
          `/course/${params.ownerSlug}/${params.courseSlug}/${
            next.chapter.slug
          }/${next.page.slug}/${next.page.id}`
        );
      }

      if (previous && e.keyCode === 37) {
        router.push(
          `/course/${params.ownerSlug}/${params.courseSlug}/${
            previous.chapter.slug
          }/${previous.page.slug}/${previous.page.id}`
        );
      }
    }
  };

  openModuleMenu = () => {
    PageLayoutActions.openModuleMenu();
  };

  newQuestion = () => {
    const hasNoneValidQuestion =
      this.state.page.pageRows &&
      this.state.page.pageRows.length &&
      this.state.page.pageRows;

    if (
      hasNoneValidQuestion &&
      hasNoneValidQuestion.filter(a => {
        return (
          a.pageModules[0].data.params.task.correctResponse === undefined ||
          !Object.keys(a.pageModules[0].data.params.task.correctResponse)
            .length ||
          !a.pageModules[0].data.params.task.correctResponse.value.length
        );
      }).length
    ) {
      this.refs.confirm.show();
    } else {
      CourseActions.addPageModule('task', this.state.page.id);
    }
  };

  closeModuleMenu() {
    PageLayoutActions.closeModuleMenu();
  }

  toggleModuleMenu() {
    PageLayoutActions.toggleModuleMenu();
  }

  toggleLayoutDesign() {
    PageLayoutActions.toggle();
  }

  openLayoutDesign() {
    PageLayoutActions.enable();
  }

  closeLayoutDesign() {
    PageLayoutActions.disable();
  }

  componentWillUnmount() {
    if (super.componentWillUnmount) {
      super.componentWillUnmount();
    }
    let app = document.getElementById('root');
    CSSPropertyOperations.setValueForStyles(app, { left: 0 });
    window.removeEventListener('keyup', this.onPageNavigate);
  }

  shouldComponentUpdate(nextProps, nextState) {
    let needsToBeOpen = nextState.tocEnabled;
    let isOpen = this.state.tocEnabled;
    if (!isOpen && needsToBeOpen) {
      this.slideAppRight();
    } else if (isOpen && !needsToBeOpen) {
      this.slideAppLeft();
    }
    return true;
    // return shallowEqual(this.state, nextState) || !shallowEqual(this.props, nextProps);
  }

  slideAppRight() {
    if (this.context.media !== 'phone') {
      let panelWidth = this.context.media === 'phone' ? 4 : 6;
      let app = document.getElementById('root');
      CSSPropertyOperations.setValueForStyles(app, {
        left: Spacing.desktopKeylineIncrement * panelWidth
      });
    }
  }

  toggleToc() {
    CourseActions.toggleToc();
  }

  openToc() {
    if (!this.state.tocEnabled) {
      if (this.state.moduleMenuEnabled) {
        this.toggleModuleMenu();
      }
      CourseActions.openToc();
    }
  }

  closeToc() {
    CourseActions.closeToc();
  }

  slideAppLeft() {
    const app = document.getElementById('root');
    CSSPropertyOperations.setValueForStyles(app, { left: 0 });
  }

  getPageStyle() {
    const style = {
      position: 'relative',
      boxSizing: 'border-box',
      margin: 'auto',
      padding: '60px 20px 68px 20px',
      overflow: 'visible'
    };
    const user = JSON.parse(localStorage.getItem('user'));
    if ((user.roles.length === 1 && user.roles.includes('reader')) || !this.state.course.canEdit) {
      style.userSelect = 'none';
    }
    if (this.context.media !== 'phone') {
      style.width = 770;
    }
    return style;
  }

  toggleApplicationMenu() {
    AppActions.toggleAppBar();
  }

  createModuleMenu(panelWidth) {
    return (
      <SlidingPanel
        initialOpen={this.state.moduleMenuEnabled}
        width={panelWidth}
        overlay={this.context.media === 'phone'}
        zIndex={4}
        ref="moduleMenu"
        onOpen={::this.openModuleMenu}
        onClose={::this.closeModuleMenu}
      >
        <ModuleMenu onCreate={::this._newModule}>
          <Toolbar style={styles.toolbar}>
            <ToolbarGroup float={'left'} key={0}>
              <ToolbarTitle
                style={styles.toolbarTitle}
                text={this.context.getIntlMessage('Modules')}
              />
            </ToolbarGroup>
            <ToolbarGroup float={'right'} key={2}>
              <ToolbarIconButton
                svgIcon={<Icons.NavigationChevronLeft />}
                onTouchTap={::this.toggleModuleMenu}
              />
            </ToolbarGroup>
          </Toolbar>
        </ModuleMenu>
      </SlidingPanel>
    );
  }

  builderMode() {
    AuthActions.builderMode();
  }

  readerMode() {
    AuthActions.readerMode();
  }

  getPageTotals() {
    const { courseHasQuiziframe, course } = this.state;
    const pageId = parseInt(this.props.params.pageId, 10);
    const toc = courseHasQuiziframe
      ? course.toc.filter(s => s.type !== 'quiz')
      : course.toc

    const pages = toc.reduce((previousValue, section) => {
        return previousValue.concat(section.pages);
    }, []);
    const pageNo = pages.findIndex(page => {
      return page.id === pageId;
    });
    return {
      pageNo: pageNo + 1,
      pageTotal: pages.length
    };
  }

  scrollIntoView = () => {
    setTimeout(() => {
      const hashbang = window.location.hash.substr(1);
      if (hashbang) {
        const el = document.getElementById(hashbang);
        el && el.scrollIntoView(true);
      }
    }, 300);
  };

  scrollModuleIntoView(pageModuleId) {
    const el = document.getElementById('pageModule-' + pageModuleId);
    el &&
      el.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
  }

  checkForQuiziframe() {
    const { toc } = this.state.course;
    const courseHasQuiz = toc.some(section => section.type === 'quiz');

    // Get the course pages.
    const pageIds = toc
      .filter(section => section.type === 'content')
      .map(section => section.pages.map(page => page.id))
      .flat();

    // Check if any page has quizIframe type. (So we can hide the old quiz)
    if (courseHasQuiz && pageIds.length > 1) {
      PageActions.checkForQuiziframe(pageIds);
    }

    this.setState({ quiziframeHasBeenChecked: true });
  }

  getNextAfterQuiz(pageId) {
    const next = CourseStore.getNextForPageId(pageId);
    if (next == null) return null;
    const { id, sectionType } = next.page;

    return (sectionType === "quiz") ? this.getNextAfterQuiz(id) : next;
  }

  getPrevBeforeQuiz(pageId) {
    const prev = CourseStore.getPreviousForPageId(pageId);
    if (prev == null) return null;
    const { id, sectionType } = prev.page;

    return (sectionType === "quiz") ? this.getPrevBeforeQuiz(id) : prev;
  }

  render() {
    const { media } = this.context;
    const { auth, pageId: PID } = this.state;
    const phone = media === 'phone' || media === 'tablet';
    if (!this.state.course || !this.state.course.theme || !this.state.page) {
      return (
        <AppPage noHeader key={pageId}>
          <Loader />
        </AppPage>
      );
    }

    if (this.state.auth.role.reader && !this.state.auth.role.editor) {
      this.state.mode = 'reader';
    } else {
      this.state.mode = 'builder';
    }

    let hasNotes = false;
    var rows = null,
      params = this.props.routeParams,
      course = this.state.course,
      quizSettings = course.settings && course.settings.quiz,
      theme = course.theme || {},
      themeColor = ThemeStore.getColor(theme.color),
      footer = null,
      pageId = parseInt(params.pageId, 10),
      next = CourseStore.getNextForPageId(pageId),
      nextPage = (next && next.page) || {},
      previous = CourseStore.getPreviousForPageId(pageId),
      previousPage = (previous && previous.page) || {},
      incarnated = auth.incarnated
        ? this.context.getIntlMessage('subAccount.incarnated')
        : '';

    // Hide prev/next buttons for old quiz.
    if (this.state.courseHasQuiziframe) {
      if (next && next.page.sectionType === 'quiz') {
        const nextAfterQuiz = this.getNextAfterQuiz(next.page.id);
        next = nextAfterQuiz;
        nextPage = (nextAfterQuiz && nextAfterQuiz.page) || {};
      }

      if (previous && previous.page.sectionType === 'quiz') {
        const previousBeforeQuiz = this.getPrevBeforeQuiz(previous.page.id);
        previous = previousBeforeQuiz;
        previousPage = (previousBeforeQuiz && previousBeforeQuiz.page) || {};
      }
    }

    if (
      this.state.layout &&
      this.state.layout.pageRows &&
      this.state.layout.pageRows.length
    ) {
      if (
        this.state.page.sectionType === 'quiz' &&
        !this.state.course.canEdit
      ) {
        rows = (
          <QuizContainer
            themeColor={themeColor}
            user={this.state.auth}
            userdata={this.state.page.userdata}
            data={this.state.layout.pageRows}
            pageId={pageId}
            courseId={course.id}
            quizSettings={
              quizSettings && quizSettings.pages && quizSettings.pages[pageId]
                ? quizSettings.pages[pageId]
                : {}
            }
          />
        );
      } else {
        rows = this.state.layout.pageRows.map(row => {
          if (!this.state.course.canEdit) {
            return (
              <PageRow
                themeColor={themeColor}
                user={this.state.auth}
                placement={row.placement}
                editor={
                  this.state.auth.role.editor && this.state.course.canEdit
                }
                reader={this.state.auth.role.reader}
                className="row"
                data={row}
                key={row.id}
                pageId={pageId}
                courseId={course.id}
                courseSlug={course.slug}
                ownerName={course.ownerName}
              />
            );
          } else {
            return (
              <PageRow
                isQuiz={this.state.page.sectionType === 'quiz'}
                themeColor={themeColor}
                user={this.state.auth}
                placement={row.placement}
                editor={
                  this.state.auth.role.editor && this.state.course.canEdit
                }
                reader={this.state.auth.role.reader}
                className="row"
                data={row}
                key={row.id}
                pageId={pageId}
                courseId={course.id}
                courseSlug={course.slug}
                ownerName={course.ownerName}
              />
            );
          }
        });
      }
    }

    const currentSection = course.toc.find(section => {
      const foundPage = section.pages.find(page => {
        return page.id === pageId;
      });
      return !!foundPage;
    });

    if (this.state.notesEnabled) {
      hasNotes = true;
      rows = (
        <NotesContainer
          router={this.props.router}
          ownerSlug={this.state.course.ownerSlug}
          courseSlug={this.state.course.slug}
          courseId={course.id}
          coruseName={course.name}
          section={currentSection && currentSection.name || ""}
        />
      );
    }

    let prevControl, nextControl;
    let shade = 'Light';
    let backgroundColor = Colors.Theme[shade].card;
    let textColor = Colors.Text[shade === 'Light' ? 'Dark' : 'Light'].secondary;
    const nextStyle = {
      fontSize: 14,
      textTransform: 'uppercase',
      color: 'rgba(255, 255, 255, 0.4)',
      marginLeft: 32,
      marginRight: 32
    };
    if (next && next.page && !next.chapter.isLocked) {
      nextControl = (
        <div
          className={css.nextControl}
          onTouchTap={this._gotoPage.bind(this, next)}
        >
          <span className={css.nextControlText}>{nextPage.name}</span>
          <Icons.NavigationChevronRight
            className={css.nextControlIcon}
            color={Colors.Colors.fullWhite}
          />
        </div>
      );
    }
    if (previous && previous.page) {
      prevControl = (
        <div
          className={css.prevControl}
          onTouchTap={this._gotoPage.bind(this, previous)}
        >
          <Icons.NavigationChevronLeft
            className={css.prevControlIcon}
            color={Colors.Colors.fullWhite}
          />
          <span className={css.prevControlText}>{previousPage.name}</span>
        </div>
      );
    }
    footer = (
      <div
        className={css.footer}
        style={{
          backgroundColor: ThemeStore.getColor(theme.color),
          color: Colors.Colors.fullWhite
        }}
      >
        {prevControl}
        {nextControl}
      </div>
    );
    let toggleTocButton;
    if (!this.state.tocEnabled) {
      // toggleTocButton = <IconButton style={{ height: 56, lineHeight: '56px', verticalAlign: 'top' }} tooltip={this.context.getIntlMessage('course.tableOfContents')} tooltipPosition='bottom-center' onTouchTap={::this.openToc}><Icons.EditorFormatListNumbered color={this.context.muiTheme.rawTheme.palette.textColor} /></IconButton>;
      // toggleTocButton = <IconButton style={{ height: 56, lineHeight: '56px', verticalAlign: 'top' }} tooltip={this.context.getIntlMessage('course.tableOfContents')} tooltipPosition='bottom-center' onTouchTap={::this.openToc}><Icons.EditorFormatListNumbered color={this.context.muiTheme.rawTheme.palette.textColor} /></IconButton>;
      toggleTocButton = (
        <ToolbarIconButton
          style={{
            backgroundColor: themeColor,
            height: 60,
            lineHeight: '60px'
          }}
          tooltip={this.context.getIntlMessage('toc.open')}
          tooltipPosition="bottom-center"
          svgIcon={<Icons.NavigationChevronRight />}
          onTouchTap={::this.openToc}
        />
      );
    }

    const { pageNo, pageTotal } = this.getPageTotals();
    let pageDisplay;
    if (media === 'phone' || media === 'tablet') {
      pageDisplay = (
        <div className={css.pageDisplay}>
          <div
            className={css.pageDisplayTitle}
            style={{
              color: themeColor
            }}
          >
            {this.state.page.name} {incarnated}
          </div>
          <div className={css.pageDisplaySubTitle}>
            {currentSection && currentSection.name}
          </div>
        </div>
      );
    } else {
      pageDisplay = (
        <div className={css.pageDisplay}>
          <div className={css.pageDisplayTitle} style={{ color: themeColor }}>
            {`${pageNo}/${pageTotal} : ${this.state.page.name} ${incarnated}`}
          </div>
        </div>
      );
    }
    let header = (
      <div style={this.getToolbarStyle(this.state.tocEnabled)}>
        {toggleTocButton}
        {pageDisplay}
      </div>
    );
    //     <FlatButton className='add-module' secondary={true} onTouchTap={this.changeTab.bind(this, 'moduleMenu')}>
    //   <i className='md md-add' />
    // </FlatButton>
    // {footer}
    let floatingActionButton;
    let { courseSlug, ownerSlug } = this.props.params;

    let moduleMenu;
    const panelWidth = phone ? 4 : 6;
    if (
      this.state.auth.role.editor &&
      this.state.page.id &&
      this.state.course.canEdit
    ) {
      floatingActionButton = (
        <FloatingActionButton
          secondary
          backgroundColor={themeColor}
          color={Colors.Colors.fullWhite}
          style={this.getFloatingActionButtonStyle()}
          onTouchTap={::this.toggleModuleMenu}
        >
          <Icons.ContentAdd />
        </FloatingActionButton>
      );
      moduleMenu = <PageModuleMenuContainer course={course} />;
    }
    let addModuleButton;
    if (this.state.auth.role.editor && this.state.course.canEdit) {
      addModuleButton = (
        <div style={styles.buttonContainer}>
          <RaisedButton
            secondary
            fullWidth
            backgroundColor={themeColor}
            onTouchTap={
              this.state.page.sectionType === 'quiz'
                ? this.newQuestion
                : this.openModuleMenu
            }
            label={
              this.state.page.sectionType === 'quiz'
                ? this.context.getIntlMessage('pageModule.quiz')
                : this.context.getIntlMessage('pageModule.add')
            }
          />
        </div>
      );
    }

    if (!this.state.quiziframeHasBeenChecked) {
      this.checkForQuiziframe();
    }

    return (
      <AppPage noHeader key={pageId}>
        {moduleMenu}
        <div className={css.page}>
          <PageLayoutContainer
            onSelectModule={pageModuleId =>
              this.scrollModuleIntoView(pageModuleId)
            }
          />
          <ScrollableContainer
            ref="page"
            header={header}
            style={{ position: 'relative' }}
            onMount={this.scrollIntoView}
          >
            <div style={this.getPageStyle()}>
              {rows}
              {!hasNotes && addModuleButton}
            </div>
          </ScrollableContainer>
          {!hasNotes && floatingActionButton}
          {!hasNotes && footer}
        </div>
        {moduleMenu}
        <Dialog
          title={this.context.getIntlMessage(
            'pageModule.quizQuestionErrorTitle'
          )}
          actions={[{ text: 'Ok' }]}
          ref="confirm"
        >
          {this.context.getIntlMessage('pageModule.quizQuestionErrorMessage')}
        </Dialog>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Page.js